import React, { useState } from "react";
import "./ComputerVisionEngineer.css";
import { Container } from "react-bootstrap";
import JobApplicationModal from "../../components/JobApplicationModal/JobApplicationModal";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader/Loader";
import arrowRight from "../../assets/utility_images/arrow-right.svg";
import arrowRightWhite from "../../assets/utility_images/arrow-right-white.svg";

const CPPEngineer = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <section className="privacy-policy-section">
          <div className="privacy-policy">
            {/* Render the first section separately */}

            <div className="policy-description">
              <div className="privacy-heading">
                JD401: Computer Vision/Algorithm Development Engineer (C++)
              </div>
              <div className="job-description">
                We are looking for highly skilled Computer Vision / Algorithm Engineers for the development of an advanced Tube Inspection System. The role involves designing and implementing high-performance image processing and 3D reconstruction algorithms for industrial inspection and precision measurement applications.
              </div>

              <div className="value-header mt-4">
                Experience Level: 3 to 4 years
              </div>
            </div>

            {/* Render the other sections */}

            <div className="policy-description">
              <div className="value-header mt-4">Key Responsibilities</div>
              <div className="job-description">
                <ul>
                  <li>
                    Development of camera calibration and image correction algorithms.
                  </li>
                  <li>
                    Design and implementation of edge detection and feature extraction techniques.
                  </li>
                  <li>
                    Development of 3D reconstruction and depth analysis algorithms.
                  </li>
                  <li>
                    CAD alignment and coordinate transformation implementation.
                  </li>
                  <li>Development of precision measurement and inspection algorithms.</li>
                  <li>Optimization of image processing performance for industrial applications.</li>
                </ul>
              </div>
              <div className="value-header mt-4">
                Required Skills & Qualifications
              </div>
              <div className="job-description">
                <ul>
                  <li>Strong programming experience in C++.</li>
                  <li>
                    Hands-on experience with OpenCV and/or HALCON.
                  </li>
                  <li>
                    Hands-on experience in CPU/GPU optimization (CUDA/OpenCL preferred).
                  </li>
                  <li>Good understanding of Image Processing and Computer Vision concepts.</li>
                  <li>
                    Experience in 3D Reconstruction and Geometry algorithms.
                  </li>
                  <li>
                    Knowledge of industrial inspection systems is preferred.
                  </li>
                  <li>
                    B.Tech / B.E in CS/IT/ECE with CGPA 7.5 +.
                  </li>
                </ul>
              </div>

              <button
                className="btn-job  d-flex justify-content-evenly align-items-center"
                onClick={handleShow} // Show modal on click
              >
                Apply
                <div className="hero-btn">
                  <img
                    className="hover-arrow"
                    src={arrowRight}
                    alt=""
                    loading="lazy"
                  />
                  <img
                    className="hover-arrow-white"
                    src={arrowRightWhite}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </button>
            </div>
          </div>
        </section>
      </Container>
      <JobApplicationModal show={show} handleClose={handleClose} />
    </div>
  );
};

export default CPPEngineer;
